import axios from '@/app/plugins/Axios'

export default new class ClientesService {

  listar() {
    return axios.get('clientes')
      .then(response => response.data);
  }

  abrir(id) {
    return axios.get('/clientes/' + id)
      .then(response => response.data);
  }

  salvar(cliente) {
    return axios.post('/clientes', cliente)
      .then(response => response.data);
  }

  atualizar(cliente) {
    return axios.put('/clientes/'+ cliente.id, cliente)
      .then(response => response.data);
  }

  excluir(id) {
    return axios.delete('/clientes/' + id)
      .then(response => response.data);
  }

  busca(busca) {
    return axios.get('/clientes/busca', { params: {search: busca} })
      .then(response => response.data);
  }
}
